import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';
import { API, BASE_URL, FRONT_MF, STORAGE_CORREDOR_KEY } from '../../../CONST';
import { fdate } from '../../../helpers/helpers';
import { patch } from '../../../helpers/requests';
import SafeBtn from '../../shared/SafeBtn';
import FileUploader from '../../shared/FileUploader';

const CorredorLiquidacionDetalleForm = ({
  liquidacion,
  setLiquidacion,
  setLiquidacionField,
  corredor,
}) => {
  const user = useSelector((state) => state.login.user);
  const [saving, setSaving] = React.useState(false);

  const liquidacionApiObj = () => ({
    id: liquidacion.id,
    factura_numero: liquidacion.factura_numero,
    folio_liquidacion: liquidacion.folio_liquidacion,
    factura_uuid: liquidacion.factura_uuid,
  });

  const handleSave = (e) => {
    e.preventDefault();
    setSaving(true);
    patch(`${BASE_URL}${API.liquidacion}/${liquidacion.id}/`, liquidacionApiObj())
      .then((resp) => setLiquidacion(resp))
      .finally(() => setSaving(false));
  };

  const facturaDownloadUrl = `${BASE_URL}${API.liquidacion}/${liquidacion.id}/download/`;

  const getOrganizationData = () => {
    let organizationData = user;

    if (user.is_orsan) {
      const data = JSON.parse(sessionStorage.getItem(STORAGE_CORREDOR_KEY));
      organizationData = {
        organization_name: data.nombre,
        organization_rut: data.rut,
      };
    }

    return organizationData;
  };

  const organization = getOrganizationData();

  return (
    <Form onSubmit={handleSave} className="form-section">
      <FormGroup row className="mb-1">
        <Label for="nombre-intermediario" sm="3">
          Intermediario
        </Label>
        <Col sm="8">
          <Input
            id="nombre-intermediario"
            className="orsan-form-element"
            value={`${organization.organization_rut} - ${organization.organization_name}`}
            style={{ padding: '6px 12px' }}
            plaintext
            disabled
          />
        </Col>
      </FormGroup>
      <FormGroup row className="mb-1">
        <Label for="periodo" sm="3">
          Período
        </Label>
        <Col sm="5">
          <Input
            id="periodo"
            className="orsan-form-element"
            value={fdate(liquidacion.periodo, FRONT_MF)}
            style={{ padding: '6px 12px' }}
            plaintext
            disabled
          />
        </Col>
      </FormGroup>
      <FormGroup row className="mb-1">
        <Label for="folio" sm="3">
          Folio de Liquidación
        </Label>
        <Col sm="5">
          <NumberFormat
            id="folio"
            className="form-control orsan-form-element"
            onValueChange={(values) =>
              setLiquidacionField('folio_liquidacion', values.floatValue || null)
            }
            decimalScale={0}
            allowNegative={false}
            value={liquidacion.folio_liquidacion}
            disabled={!!corredor}
          />
        </Col>
      </FormGroup>
      <FormGroup row className="mb-1">
        <Label for="numero_factura" sm="3">
          Número de Factura
        </Label>
        <Col sm="5">
          <NumberFormat
            id="numero_factura"
            className="form-control orsan-form-element"
            onValueChange={(values) =>
              setLiquidacionField('factura_numero', values.floatValue || null)
            }
            decimalScale={0}
            allowNegative={false}
            value={liquidacion.factura_numero}
            disabled={!!corredor}
          />
        </Col>
      </FormGroup>
      <FormGroup row className="mb-1">
        <Label for="numero_factura" sm="3">
          Cargar Factura
        </Label>
        <Col sm="5">
          <FileUploader
            uploadUrl={`${BASE_URL}${API.uploadDocumento}/`}
            inputText="Seleccione un archivo (.pdf)"
            accept=".pdf"
            handleResponse={({ uuid }) => setLiquidacionField('factura_uuid', uuid)}
            existentFile={
              liquidacion.factura
                ? {
                    id: liquidacion.factura.id,
                    name: liquidacion.factura.original_name,
                    downloadUrl: corredor
                      ? `${facturaDownloadUrl}?corredor_id=${corredor.id}`
                      : facturaDownloadUrl,
                  }
                : undefined
            }
            disabled={!!corredor}
          />
        </Col>
        <Col sm="2">
          <SafeBtn
            color="orsan-secondary"
            className="float-left"
            style={{ width: '100px', fontSize: '14px' }}
            loading={saving}
            disabled={
              saving ||
              !liquidacion.folio_liquidacion ||
              !liquidacion.factura_numero ||
              (!liquidacion.factura_uuid && !liquidacion.factura) ||
              !!corredor
            }
          >
            Guardar
          </SafeBtn>
        </Col>
      </FormGroup>
    </Form>
  );
};

CorredorLiquidacionDetalleForm.propTypes = {
  liquidacion: PropTypes.shape({
    id: PropTypes.number,
    tipo: PropTypes.shape({
      descripcion: PropTypes.string,
    }).isRequired,
    periodo: PropTypes.string,
    folio_liquidacion: PropTypes.number,
    factura_numero: PropTypes.number,
    factura_uuid: PropTypes.string,
    factura: PropTypes.shape({
      id: PropTypes.number,
      original_name: PropTypes.string,
    }),
  }).isRequired,
  setLiquidacion: PropTypes.func.isRequired,
  setLiquidacionField: PropTypes.func.isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  }),
};

CorredorLiquidacionDetalleForm.defaultProps = {
  corredor: null,
};

export default CorredorLiquidacionDetalleForm;
